import React, { useContext, useEffect, useState } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { useUploadDataStatus } from '../../../hooks/Others/useUploadDataStatus'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { formatDate, formatTime, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router-dom'

export default function OverviewTable({ module, redirect }) {
  const { getAllUploadDataStatus, paginate, loading } = useUploadDataStatus()
  const history = useHistory()
  const { uploadedData } = useContext(OtherContext)

  const [searchQuery, setSearchQuery] = useState('')
  const filterUploadedData = uploadedData
  const [page, setPage] = React.useState(1)
  //console.log('UPLOADED DATA : ', filterUploadedData)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllUploadDataStatus({
      page: page,
      limit: 10,
      searchQuery,
      module: module === 'SFTP' ? 'SALES' : module,
      isSftpUpload: module === 'SFTP' ? true : false,
    })
  }, [page, searchQuery])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  if (!loading && filterUploadedData.length > 0) {
    tableBody =
      filterUploadedData &&
      filterUploadedData.map((item) => {
        return [
          { value: formatDate(item.updatedAt) },
          { value: formatTime(item.updatedAt) },
          { value: item.failedData.length + item.successData.length },
          { value: item.failedData.length },
          { value: item.successData.length },
          // { value: item.uploadedBy.firstName },
          // { value: item.uploadedBy.userType === 'ALLEMPLOYEE' ? item.uploadedBy.position && item.uploadedBy.position.positionName : item.uploadedBy.userType },
          { type: 'INFO', onClick: () => history.push(`/upload-status/${redirect ? redirect : module.toLowerCase()}/${item._id}`) },
        ]
      })
  }

  const layoutProps = {
    heading: `TOTAL OVERVIEW ${module} UPLOADS`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
  }

  //console.log('TABLE BODY : ', tableBody)
  return (
    <CustomTableLayout
      tableHeadings={['uploaded Date', 'upload time', 'total Upload', 'Failed upload', 'success upload', 'info']}
      loading={loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
    />
  )
}
